import { render, staticRenderFns } from "./InstitutionalProjectReview.vue?vue&type=template&id=7828b4cf&scoped=true"
import script from "./InstitutionalProjectReview.vue?vue&type=script&lang=js"
export * from "./InstitutionalProjectReview.vue?vue&type=script&lang=js"
import style0 from "./InstitutionalProjectReview.vue?vue&type=style&index=0&id=7828b4cf&prod&scoped=true&lang=css"
import style1 from "./InstitutionalProjectReview.vue?vue&type=style&index=1&id=7828b4cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7828b4cf",
  null
  
)

export default component.exports